var $ = require('jquery');

module.exports = function () {

    if (typeof $.validator === 'undefined' || typeof $.fn.validate === 'undefined') {
        throw new Error('validatorTip method requires jquery.validate')
    }
    if (typeof $.fn.tooltip === 'undefined') {
        throw new Error('validatorTip method requires $.fn.tooltip')
    }
    //设置验证样式类名
    $.extend( $.validator.defaults,{
        errorClass: "validator_error",
        pendingClass: "validator_pending",
        validClass: "validator_valid",
        onfocusin: function( element ) {
            this.lastActive = element;

            // Hide error label and remove error class on focus if enabled
            if ( this.settings.focusCleanup ) {
                if ( this.settings.unhighlight ) {
                    this.settings.unhighlight.call( this, element, this.settings.errorClass, this.settings.validClass );
                }
                this.hideThese( this.errorsFor( element ) );
                clearCustomError(element);
            }
        },
        onfocusout: function( element ) {
            /*
             element.name in this.submitted || !this.optional( element )
             必填项只有在输入之后或者检验所有的时候会开始校验
            * */
            if ( !this.checkable( element ) && ( element.name in this.submitted || !this.optional( element ) ) ) {
                this.element( element );
            }
        }
    });
    (function () {
        var proto = $.validator.prototype;
        var p_showErrors = proto.showErrors;
        $.extend(proto,{
            showErrors:function (errors) {
                if ( errors ) {
                    // Add items to error submitted
                    $.extend( this.submitted, errors );
                }
                p_showErrors.call( this, errors );
            },
            repositionTip:function () {
                $( this.currentForm ).find('[data-original-title]').each(function () {
                    var $this = $(this);
                    var data  = $this.data('bs.validatorTip');
                    data &&  data.$tip.is(':visible') && data.show.call(data);
                });
            }
        });
    })();

    /**
     *
     * @param customErrorPlacement :  增加jquery.fn.validate()一项配置 customErrorPlacement
     *    [
     *      {
         *        pattern:'elementNameRegExp',//匹配验证元素名字的正则字符串
         *        placement:placement//怎么提示错误，参见例placement
         *      }
     *    ]
     *
     * @param name
     * @returns {*}
     */
    function getCustomErrorPlacement(customErrorPlacement,name) {
        //例placement
        var placement = function (element,message) {
            $(element).validatorTip('timingShow',message);
            return function () {
                $(element).validatorTip('timingShow');
            };
        };

        customErrorPlacement && customErrorPlacement.forEach(function (custom) {
            var reg;

            if(custom && custom.pattern && $.type(custom.placement) === 'function'){
                reg = $.type(custom.pattern) === "string" ? new RegExp("^(?:" + custom.pattern + ")$"):custom.pattern;
                if(reg.test(name)){
                    placement = custom.placement;
                    return false;
                }
            }
        });

        return placement;
    }
    function dealPlacement(customErrorPlacement,element,message) {
        var errorPlacement;

        if(!(element instanceof jQuery)){
            element = $(element);
        }

        errorPlacement = getCustomErrorPlacement(customErrorPlacement,element[0].name);

        element.data('customErrorClear',errorPlacement(element,message));
    }
    function clearCustomError(element) {
        var customErrorClear = $(element).data('customErrorClear');
        $.type(customErrorClear) === 'function' && customErrorClear();
        $(element).data('customErrorClear',null);
    }

    function showErrors(errorMap,errorList) {
        var i, elements, error;
        for ( i = 0; this.errorList[ i ]; i++ ) {
            error = this.errorList[ i ];
            if ( this.settings.highlight ) {
                this.settings.highlight.call( this, error.element, this.settings.errorClass, this.settings.validClass );
            }
            // this.showLabel( error.element, error.message );
            dealPlacement(this.settings.customErrorPlacement,error.element,error.message);
        }
        /*if ( this.errorList.length ) {
         this.toShow = this.toShow.add( this.containers );
         }
         if ( this.settings.success ) {
         for ( i = 0; this.successList[ i ]; i++ ) {
         this.showLabel( this.successList[ i ] );
         }
         }*/
        if ( this.settings.unhighlight ) {
            for ( i = 0, elements = this.validElements(); elements[ i ]; i++ ) {

                clearCustomError(elements[ i ]);

                this.settings.unhighlight.call( this, elements[ i ], this.settings.errorClass, this.settings.validClass );
            }
        }
        /*this.toHide = this.toHide.not( this.toShow );
         this.hideErrors();
         this.addWrapper( this.toShow ).show();*/
    }
    (function () {
        var ValidatorTip = function (element, options) {
            this.timingShowTimeout    = null;
            this.init('validatorTip', element, options);
        };

        ValidatorTip.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
            template: '<div class="tooltip validator-tip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
            trigger: 'manual',
            placement: 'right',
            delay: {
                show:1,//ValidatorTip.prototype.timingShow 里当元素不在可视范围时延迟展示，为0时会立即展示
                hide:0
            },
            timingShow:1000,
            html: true
        });

        ValidatorTip.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype);

        ValidatorTip.prototype.constructor = ValidatorTip;

        ValidatorTip.prototype.getDefaults = function () {
            return ValidatorTip.DEFAULTS
        };

        ValidatorTip.prototype.replaceArrow = function (delta, dimension, isVertical) {
            /*this.arrow()
                .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
                .css(isVertical ? 'top' : 'left', '');*/
        };
        ValidatorTip.prototype._timingHide = function (callback) {
            var that = this;
            var $tip = $(this.$tip);
            var e    = $.Event('hide.bs.' + this.type);

            function complete() {
                if (that.hoverState != 'in') $tip.detach();
                if (that.$element) { // TODO: Check whether guarding this code with this `if` is really necessary.
                    that.$element
                        .removeAttr('aria-describedby')
                }
                callback && callback()
            }

            if (e.isDefaultPrevented()) return;

            $tip.removeClass('in');

            that.hoverState = 'out';//状态设为离开

            $.support.transition && $tip.hasClass('fade') ?
                $tip
                    .one('bsTransitionEnd', complete)
                    .emulateTransitionEnd($.fn.tooltip.Constructor.TRANSITION_DURATION) :
                complete();

            return this
        };
        ValidatorTip.prototype.timingShow = function (msg) {
            var self = this;
            var $e = this.$element;
            var o  = this.options;

            clearTimeout(self.timingShowTimeout);
            clearTimeout(self.timeout);
            if (msg || msg === 0) {
                if(self.getTitle()!==msg){
                    self._timingHide(function () {
                        $e.attr('data-original-title',o.title = msg);
                        timingShowTip(self);
                    });
                }else{
                    $e.attr('data-original-title',o.title = msg);
                    timingShowTip(self);
                }
                /*
                测试代码
                self.hoverState = 'out';
                this.tip().removeClass('in');
                $e.attr('data-original-title',o.title = msg);
                timingShowTip(self);
                */
            }else {
                $e.attr('data-original-title',o.title = '');
                self.setContent();
                self.leave(self);
            }
            function timingShowTip(self) {
                var offset = self.$element.offset();

                //当元素不在可视范围时延迟定位，否则立即定位
                if(offset.top<0 || offset.left<0){
                    replaceTip();
                }else{
                    self.enter(self);
                }

                function replaceTip() {
                    var timingShow = $.type(self.options.timingShow) === 'number' && self.options.timingShow >0
                        ?self.options.timingShow : ValidatorTip.DEFAULTS.timingShow;

                    clearTimeout(self.timingShowTimeout);
                    self.timingShowTimeout = setTimeout(function () {
                        var offset = self.$element.offset();
                        if (self.hasContent()) {
                            if(offset.top<0 || offset.left<0){
                                replaceTip();
                            }
                            self.show();
                        }
                    }, timingShow);
                }
            }
        };

        function Plugin(option) {
            var param = [].slice.call( arguments, 1);
            return this.each(function () {
                var $this   = $(this);
                var data    = $this.data('bs.validatorTip');
                var options = typeof option == 'object' && option;

                if (!data && /destroy|hide/.test(option)) return;
                if (!data) $this.data('bs.validatorTip', (data = new ValidatorTip(this, options)));
                if (typeof option == 'string') data[option].apply(data,param);
            })
        }

        $.fn.validatorTip             = Plugin;
        $.fn.validatorTip.Constructor = ValidatorTip;
    })();
    /**
     * @description 重置元素验证
     * @returns {*}
     */
    $.fn.validatorTipReset = function () {
        return this.each(function () {
            var $this = $(this);
            if( this.form && $.data( this.form, "validator" )){
                $.data( this.form, "validator" ).resetElements( $this );
                $this.validatorTip('timingShow');
            }
        });
    };

    return {
        showErrors:showErrors//参见jquery.fn.validate()
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/plugins/jquery-validation-tip.js
// module id = 200
// module chunks = 0